import React from 'react';

const Hero = () => {
  return (
    <section id="portafolio" className="hero">
      <div className="container">
        <h1>Diseñador & Desarrollador</h1>
        <p>Creando experiencias digitales únicas y funcionales</p>
        <button className="hero-btn" onClick={() => document.getElementById('projects').scrollIntoView()}>
          Ver Proyectos
        </button>
      </div>
    </section>
  );
};

export default Hero;